import { postRequest } from '../clients/axios';
import { Contract } from '../models';
import { PlayerContractPayload } from '../models/PlayerContractPayload';

interface UpsertPlayerContractResponse {
  playerId: number;
  contract: Contract;
}

export const postUpsertPlayerContract = async (data: PlayerContractPayload): Promise<UpsertPlayerContractResponse | undefined> => {
  try {
    const url = 'player/UpsertPlayerContract';
    const response = await postRequest<UpsertPlayerContractResponse>(url, data);
    return response.data;
  } catch (error: any) {
    // API triggers an error if user clicks save button without changes. Not an actual error.
    console.error(error.response?.data);
    return;
  }
};
